/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { Popover, Progress, Typography } from "antd";
import PopOverHours from "./PopOverHours";

function HourCard(props: any) {
  const {
    column,
    isWeekend,
    hoursData,
    totalScheduledHours,
    // selectedDate,
    // index,
  } = props;
  const [openHours, setOpenHours] = useState(false);
  // const isToday = selectedDate
  //   ? new Date(selectedDate).toDateString() === new Date().toDateString()
  //   : false;

  const handleOpenHoursChange = (newOpen: boolean) => {
    setOpenHours(newOpen);
  };
  return (
    <div className="column_info_item" style={{ cursor: "pointer" }}>
      <Popover
        trigger="click"
        arrow={false}
        placement="bottomLeft"
        open={openHours}
        onOpenChange={handleOpenHoursChange}
        content={<PopOverHours />}
      >
        {column ? (
          <span
            style={{
              marginBottom: "4px",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            Hours
            {/* {isToday && index === 0 && (
              <img src="/images/potential-deals/octagon-warning.svg" alt="" />
            )} */}
          </span>
        ) : (
          <Typography.Text
            type="secondary"
            style={{
              fontSize: "12px",
              display: "block",
              color: "#151718",
              textAlign: "left",
              fontWeight: 400,
            }}
          >
            Hours
          </Typography.Text>
        )}

        {column ? (
          <div style={{ whiteSpace: "nowrap" }}>
            {totalScheduledHours || "0"} / {column?.crewMembers?.length * 8}{" "}
            <Progress
              strokeColor="#00A07D"
              percent={(totalScheduledHours / 32) * 100}
              size={["37px", 6]}
              style={{
                marginLeft: "4px",
                display: "inline-flex",
                width: "32px",
              }}
            />
          </div>
        ) : !isWeekend ? (
          hoursData ? (
            <>
              <div
                style={{
                  whiteSpace: "nowrap",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <Typography.Title
                  level={5}
                  style={{ margin: "0", fontSize: "1em" }}
                >
                  {totalScheduledHours ?? 0}/{32}
                </Typography.Title>
                <Progress
                  percent={((totalScheduledHours ?? 0) / 32) * 100}
                  showInfo={false}
                  strokeColor="#00A07D"
                  size="small"
                  style={{ width: "40px", marginTop: "0" }}
                />
              </div>
            </>
          ) : (
            <Typography.Text
              type="secondary"
              style={{
                fontSize: "12px",
                color: "#151718",
                display: "block",
                textAlign: "left",
                fontWeight: 600,
              }}
            >
              N/A
            </Typography.Text>
          )
        ) : (
          <Typography.Text
            type="secondary"
            style={{
              fontSize: "12px",
              color: "#151718",
              display: "block",
              textAlign: "left",
              fontWeight: 600,
            }}
          >
            0/0
          </Typography.Text>
        )}
      </Popover>
    </div>
  );
}

export default HourCard;
